var map = {
	"./apidays-2020-facts.png": "2f9b",
	"./apidays-HongKong-logowall.png": "dce6",
	"./apidays-banner-light.jpg": "c68a",
	"./apidays-banner.jpg": "9848",
	"./apidays-live-hongkong-2020agenda.png": "c9a2",
	"./apidays-onsite-1.jpg": "2102",
	"./apidays-onsite-2.jpg": "e25e",
	"./apidays-onsite-3.jpg": "c3f6",
	"./apidays-ppt-1.png": "72c2",
	"./apidays-ppt-2.png": "8c73",
	"./apidays-ppt-3.png": "9c49",
	"./apidays-ppt-4.png": "2969",
	"./apidays-ppt-5.png": "3c06",
	"./apidays.jpg": "c47d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4ddb";